<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <h1 class="page__title text-center">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody>
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0" alignHorizontal="between">
                    <CCol md="5">
                        <!-- Filter -->
                        <CSelect
                            :label="$t('langs') + ':'"
                            :placeholder="$t('select_a_lang')"
                            :horizontal="{
                                label: 'col-sm-3',
                                input: 'col-sm-9',
                            }"
                            :isValid="isValidLandId()"
                            :invalidFeedback="$t('this_field_is_required')"
                            :options="storeLangLocales"
                            :value.sync="$v.langId.$model"
                        />
                    </CCol>
                    <CCol md="5"> </CCol>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="11" sm="12">
                        <CDataTable
                            v-bind="tables.translations"
                            :items.sync="tables.translations.items"
                        >
                            <template #over-table>
                                <CDropdown
                                    color="primary"
                                    :toggler-text="$t('actions')"
                                    class="m-2"
                                >
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="
                                            downloadExportTable({
                                                tableName: 'translations',
                                            })
                                        "
                                    >
                                        <strong>{{ $t("export") }}</strong>
                                    </CDropdownItem>
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="openModalMergeLangs()"
                                    >
                                        <strong>{{ $t("merge_langs") }}</strong>
                                    </CDropdownItem>
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="openModalAddLang()"
                                    >
                                        <strong>{{
                                            $t("add_lang")
                                        }}</strong>
                                    </CDropdownItem>
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="
                                            actionSelectAllTranslations(
                                                'translations'
                                            )
                                        "
                                    >
                                        <strong>{{ $t("select_all") }}</strong>
                                    </CDropdownItem>
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="
                                            actionDeleteSelectedTranslations()
                                        "
                                    >
                                        <strong>{{
                                            $t("delete_selected")
                                        }}</strong>
                                    </CDropdownItem>
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="addTranslation()"
                                    >
                                        <strong>{{
                                            $t("add_translation")
                                        }}</strong>
                                    </CDropdownItem>
                                    <CDropdownItem
                                        tag="div"
                                        class="text-cent\er"
                                        @click="sendData()"
                                        :disabled="
                                            !hasChanges || !isValidLandId()
                                        "
                                    >
                                        <strong>{{
                                            $t("save_changes")
                                        }}</strong>
                                    </CDropdownItem>
                                    
                                </CDropdown>
                            </template>
                            <template #_selected="{ item }">
                                <td class="py-2">
                                    <CInputCheckbox
                                        :checked.sync="
                                            tables.translations.tempItems[
                                                item.index
                                            ]._selected
                                        "
                                    />
                                </td>
                            </template>
                            <template #key="{ item }">
                                <td>
                                    <CInput
                                        :value.sync="
                                            tables.translations.tempItems[
                                                item.index
                                            ].key
                                        "
                                        size="sm"
                                    />
                                </td>
                            </template>
                            <template #value="{ item }">
                                <td>
                                    <CInput
                                        :value.sync="
                                            tables.translations.tempItems[
                                                item.index
                                            ].value
                                        "
                                        size="sm"
                                    />
                                </td>
                            </template>
                        </CDataTable>
                    </CCol>
                </CRow>
                <AddLangModal
                    :show.sync="modals.addLang.show"
                    :title="$t('add_lang')"
                    v-bind="modals.addLang"
                />
                <MergeLangsModal
                    :show.sync="modals.mergeLangs.show"
                    :title="$t('merge_langs')"
                    v-bind="modals.mergeLangs"
                />
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Components */
import FilterFields from "~/components/FilterFields";
import AddLangModal from "~/pages/Admin/Langs/components/AddLangModal";
import MergeLangsModal from "~/pages/Admin/Langs/components/MergeLangsModal";

/** Others */
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
    name: "LangsManagerAdminPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, validationMixin],
    // layout: "admin",
    components: {
        FilterFields,
        AddLangModal,
        MergeLangsModal
    },
    data() {
        return {
            langId: null,
            tables: {
                translations: {
                    items: [],
                    tempItems: [],
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            sortable: false,
                            filter: false,
                        },
                        {
                            key: "key",
                            label: this.$t("key"),
                            sortable: true,
                            _filter: true,
                        },
                        {
                            key: "value",
                            label: this.$t("value"),
                            sortable: true,
                            _filter: true,
                        },
                    ],
                    columnFilter: {
                        lazy: true,
                    },
                    columnFilterValue: {},
                    "items-per-page-select": true,
                    hover: true,
                    sorter: true,
                    loading: false,
                    pagination: {
                        align: "center",
                    },
                },
            },
            modals: {
                addLang: {
                    show: false,
                    color: "primary",
                    data: {
                        locales: []
                    }
                },
                mergeLangs:{
                    show: false,
                    color: "primary",
                    data: {
                        locales: [],
                        langId: null
                    }
                }
            },
        };
    },
    computed: {
        ...mapGetters({
            storeLangLocales: "lang/locales",
        }),
        hasChanges() {
            return (
                JSON.stringify(this.tables.translations.tempItems) !==
                JSON.stringify(this.tables.translations.items)
            );
        },
    },
    watch: {
        langId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.updateData(newVal);
            }
        },
    },

    validations: {
        langId: {
            required,
        },
    },
    methods: {
        afterAddLang(){

        },
        openModalAddLang() {
            this.modals.addLang.data = {
                ...this.modals.addLang.data,
                locales: this.storeLangLocales,
            }
            this.modals.addLang.show = true;
        },
        openModalMergeLangs() {
            if (!this.isValidLandId() || this.hasChanges) {
                this.$v.langId.$touch();
                throw new Error("Can't merge langs");
            }
            this.modals.mergeLangs.data = {
                ...this.modals.mergeLangs.data,
                locales: this.storeLangLocales,
                langId: this.langId
            }
            this.modals.mergeLangs.show = true;
        },
        actionDeleteSelectedTranslations() {
            if (!this.isValidLandId()) {
                this.$v.langId.$touch();
                throw new Error("Invalid langId");
            }
            this.tables.translations.tempItems =
                this.tables.translations.tempItems.filter((item) => {
                    return !item._selected;
                });
        },
        async actionSelectAllTranslations() {
            if (!this.isValidLandId()) {
                this.$v.langId.$touch();
                throw new Error("Invalid langId");
            }
            await this.actionSelectAllItems("translations");
            this.tables.translations.tempItems = JSON.parse(
                JSON.stringify(this.tables.translations.items)
            );
        },
        addTranslation() {
            if (!this.isValidLandId()) {
                this.$v.langId.$touch();
                throw new Error("Invalid langId");
            }
            let defaultItem = this.getDefaultTableItem("translations");
            defaultItem = {
                ...defaultItem,
                index: this.tables.translations.items.length,
                _selected: false,
            };
            this.tables.translations.items.push(defaultItem);
            this.tables.translations.tempItems.push(
                JSON.parse(JSON.stringify(defaultItem))
            );
        },
        async updateData() {
            await this.updateTable({
                tableName: "translations",
                fetch: {
                    // baseURL:"https://leadgrease-locales.s3.eu-west-1.amazonaws.com",
                    baseURL: process.env.VUE_APP_LANGS_BUCKET,
                    url: this.langId + ".json",
                    headers: {
                        "Cache-Control": "no-cache",
                    },
                    query: null,
                },
                customFields: {
                    _selected: false,
                },
                adapterData: async (tableData) => {
                    let adaptedData = [];
                    let count = 0;
                    for (const key in tableData) {
                        if (Object.hasOwnProperty.call(tableData, key)) {
                            const element = tableData[key];
                            adaptedData.push({
                                key: key,
                                value: element,
                                index: count++,
                            });
                        }
                    }
                    return (tableData = {
                        _items: adaptedData,
                    });
                },
            });

            this.tables.translations.tempItems = JSON.parse(
                JSON.stringify(this.tables.translations.items)
            );
        },
        isValidLandId() {
            let valLandId = this.$v.langId;
            if (!valLandId) return false;
            if (!valLandId.$dirty) {
                return null;
            }
            return !(valLandId.$invalid || valLandId.$model === "");
        },
        async sendData() {
            try {
                if (!this.isValidLandId()) {
                    this.$v.langId.$touch();
                    throw new Error("Invalid langId");
                }

                this.tables.translations.loading = true;
                this.tables.translations.items = JSON.parse(
                    JSON.stringify(this.tables.translations.tempItems)
                );

                let translations = {};
                for (
                    let i = 0;
                    i < this.tables.translations.items.length;
                    i++
                ) {
                    const element = this.tables.translations.items[i];
                    translations = {
                        ...translations,
                        [element.key]: element.value,
                    };
                }

                await this.fetcher({
                    // baseURL: "https://jky3mgfb87.execute-api.eu-west-1.amazonaws.com",
                    baseURL: process.env.VUE_APP_API_CORE,
                    url: `/langs/${this.langId}`,
                    method: "PUT",
                    data: translations,
                });

                /* this.tables.translations.items = JSON.parse(
                    JSON.stringify(this.tables.translations.tempItems)
                ); */

                this.tables.translations.loading = false;

                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            }
        },
    },
    mounted() {
        this.updatePageLoading(false);
    },
};
</script>

<style>
</style>